import AdminHotelSearch from './admin-hotel-search/admin-hotel-search-component';
import AdminHotelSearchService from './admin-hotel-search/admin-hotel-search-service';
import AdminHotelSearchResults from './admin-hotel-search-results/admin-hotel-search-results-component';
import AdminHotelListService from './admin-hotel-list-service';

import './admin-hotel-list.scss';

const MODULE_NAME = 'App.admin.hotel-list';
const module = angular
    .module(MODULE_NAME, [
        'app.constants',
        'app.admin.states',
        'App.Services',
    ])
    .directive(AdminHotelSearch.DIRECTIVE_NAME, AdminHotelSearch)
    .directive(AdminHotelSearchResults.DIRECTIVE_NAME, AdminHotelSearchResults)
    .service('adminHotelListService', AdminHotelListService)
    .service('adminHotelSearchService', AdminHotelSearchService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-hotel-list/admin-hotel-list-module.js